/** Backend menu / entity-group codes for playthrough (wagering) profiles. */
export const WAGERING_PROFILES_ENTITY_CODE = 'wagering-profiles';
export const WAGERING_PROFILES_OVERALL_GROUP = 'overall';

/** Fallback card title when form config does not provide one. */
export const WAGERING_PROFILES_OVERALL_TITLE = 'Overall';
